export default "static/media/logo-light.e4199b7.png"